import religious from "./religious.js";
import hills from "./hills.js";
import lakes from "./lakes.js";
import wildlife from "./wildlife.js";
import adventure from "./adventure.js";
import heritage from "./heritage.js";
import itineraries from "./itineraries.js";
import { IMG } from "../images.js";

const ALL = [...religious, ...hills, ...lakes, ...wildlife, ...adventure, ...heritage, ...itineraries].map((d) => ({
  categories: [d.category],
  near: [],
  startFrom: ["Dehradun", "Haridwar", "Rishikesh"],
  attractions: [],
  activities: [],
  permits: null,
  accessNote: null,
  imgNote: null,
  featured: false,
  ...d,
  images: d.images || IMG[d.slug] || [],
}));

export const DESTINATIONS = ALL;
export const DESTINATION_BY_SLUG = Object.fromEntries(ALL.map((d) => [d.slug, d]));
export const ITINERARIES = itineraries;

export const CATEGORIES = [
  { id: "religious", label: "Char Dham & Religious" },
  { id: "hills", label: "Hill Stations" },
  { id: "lakes", label: "Lakes & Waterfalls" },
  { id: "wildlife", label: "Wildlife & Parks" },
  { id: "adventure", label: "Adventure & Trekking" },
  { id: "itinerary", label: "Family Holidays" },
  { id: "heritage", label: "Heritage & Culture" },
];

export const ACCESS_LABEL = {
  road: "Drive direct",
  "road+trek": "Drive + short trek",
  trek: "Trek only",
  restricted: "Restricted access",
};

export const ACCESS_HINT = {
  road: "Taxi travels to the destination",
  "road+trek": "Taxi reaches the base; final stretch on foot",
  trek: "No road access — taxi to the trail head only",
  restricted: "Entry governed by official rules; check before planning",
};

export const FEATURED = ALL.filter((d) => d.featured);
export const FEATURED_12 = [
  "kedarnath", "badrinath", "mussoorie", "rishikesh", "har-ki-pauri", "nainital",
  "auli", "chopta", "valley-of-flowers", "jim-corbett", "tehri-lake", "munsiyari",
].map((s) => DESTINATION_BY_SLUG[s]).filter(Boolean);

export const CHAR_DHAM = ["yamunotri", "gangotri", "kedarnath", "badrinath"].map((s) => DESTINATION_BY_SLUG[s]);

export const ACTIVITIES = [
  { slug: "river-rafting-rishikesh", title: "River Rafting, Rishikesh", desc: "Grade III–IV rapids on the Ganga with licensed operators — we handle the drive and timings.", images: IMG.rafting },
  { slug: "camping", title: "Camping Under the Stars", desc: "Meadow and forest camps across Garhwal and Kumaon — bonfires, tents and pure night sky.", images: IMG.camping },
  { slug: "skiing-auli", title: "Skiing in Auli", desc: "India's ski meadow each winter — ropeway access, slopes for every level, subject to snow.", images: IMG.skiing },
  { slug: "nature-walks", title: "Nature Walks & Forest Trails", desc: "Deodar and oak forests, eco-parks and village paths — the slow way to know the hills.", images: IMG.nature_walks },
  { slug: "mountain-photography", title: "Mountain Photography", desc: "Sunrise panoramas, temple spires and river confluences — we time the light for your lens.", images: IMG.photography },
  { slug: "stargazing", title: "Stargazing & Night Skies", desc: "The high meadows and camps of Uttarakhand hold some of India's darkest skies.", images: IMG.stargazing },
];

export const seoFor = (d) => {
  if (d.seo) return d.seo;
  const from = d.startFrom && d.startFrom.length ? d.startFrom[0] : "Dehradun";
  const kind = d.category === "adventure" ? "Trek & Travel" : d.category === "itinerary" ? "Weekend Trip" : "Taxi & Travel Guide";
  return {
    title: `${d.name} ${kind} — Cab from ${from} | Tingadya Travels`,
    description: `${d.name} travel with Tingadya Travels: Ertiga taxi trips from ${from}, access and season guidance, and easy taxi enquiry for ${d.name}.`,
  };
};
